"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    footerRegion: 'US',
    regions: [
        {
            imgUrl: "https://genesis-cdn.ff.com/icon-en.png",
            value: "US",
            domain: "https://www.ff.com/us/"
        },
        {
            imgUrl: "https://genesis-cdn.ff.com/icon-china.png",
            value: "CN",
            domain: "https://www.faradayfuturecn.com/cn/"
        }
    ],
    items: [
        {
            sectionTitle: "ABOUT US",
            links: [
                { url: "/our-company", label: "Our Company" },
                { url: "/our-approach", label: "Our Approach" },
                { url: "/our-team", label: "Our Team" },
                { url: "/press-room", label: "Press Room" },
                { url: "/futuresight", label: "Blog" },
                { url: "/ff-zero-1", label: "FF Zero 1" },
                { url: "/gallery", label: "FF Gallery" },
                { url: "/solutions", label: "Solutions" },
                { url: "https://investors.ff.com", label: "Investors" },
            ]
        },
        {
            sectionTitle: "SUPPORT",
            links: [
                { url: "/contact-us", label: "Contact Us" },
                { url: "/newsletter-subscribe", label: "Newsletter" },
                { url: "/frequently-asked-questions", label: "FAQ" },
                { url: "/careers", label: "Careers" },
                { url: "/sitemap", label: "Sitemap" },
                { url: "/privacy-policy", label: "Privacy Policy" },
                { url: "/terms-of-use", label: "Terms of Use" },
            ]
        }
    ],
    socialLinks: [
        {
            url: "https://www.linkedin.com/company/faradayfuture",
            icon: "ff-icon-social-linkedin"
        },
        {
            url: "https://www.youtube.com/c/faradayfuture",
            icon: "ff-icon-social-youtube"
        },
        {
            url: "https://twitter.com/faradayfuture?lang=en",
            icon: "ff-icon-social-twitter"
        },
        {
            url: "https://www.facebook.com/faradayfuture/",
            icon: "ff-icon-social-facebook"
        },
        {
            url: "https://www.instagram.com/faradayfuture/",
            icon: "ff-icon-social-instagram"
        },
        {
            url: 'https://genesis-cdn.faradayfuturecn.com/WeChat%20QR%20code.jpg',
            icon: 'ff-icon-social-wechat'
        },
    ],
    copyright: {
        text: "© {year} Faraday&Future Inc. The Faraday Future name and logo are trademarks of Faraday&Future Inc. All rights reserved.",
        link_url: 'https://beian.miit.gov.cn/',
        link_text: '京ICP备19018825号-1',
        icon_url: '',
        show_horizontal_alignment: true,
        moreLinks: [{
                url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045145',
                text: '京公网安备 11010502045145号',
                icon_url: 'https://genesis-cdn.ff.com/beian-icon.png',
            }]
    },
    download: {
        url: 'https://www.ff.com/us/mobile-app',
        title: 'DOWNLOAD FF INTELLIGENT APP',
        appButtonText: 'INSTALL APP',
        iosStoreLink: 'https://itunes.apple.com/us/app/id1454187098',
        iosAppLink: 'https://faradayfuture.app.link',
        iosImage: '',
        androidStoreLink: 'https://play.google.com/store/apps/details?id=com.faradayfuture.online',
        androidAppLink: 'faradayfuture://feed',
        androidApkLink: 'https://www.ff.com/us/mobile-app/',
        androidImage: ''
    },
    subscribeForm: {
        enabled: true,
        submitUrl: '/api/subscribe',
        title: 'Get the latest news and important updates from FF',
        subtitle: 'Sign up for the latest of the FF 91 Futurist and other news about Faraday Future',
        inputPlaceholder: 'Email*',
        inputErrorMessage: 'Please provide a valid email',
        serverErrorMessage: 'Something went wrong. Please try again later.',
        successMessage: 'Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.',
        button: 'Subscribe →',
    }
};
exports.default = defaultProps;
